import React from 'react';
import styled, { css } from '../../styled/index';
import * as Icons from '../icons';
import * as ImagePreview from '../imagePreview';
import Text from '../text';
import TextLink from '../textLink';
import * as Tooltip from '../tooltip';
import dayjs from '../dateLabel/day';
const URL_MAX_LENGTH = 35;
const URL_ELLIPSIS_BEGIN_AT_INDEX = 15;
const ELLIPSIS_SYMBOL = '...';
const TextWrapper = styled.div `
  background-color: ${({ isOwner, status, theme }) => theme.colors[theme.messageBubble.backgroundColor(isOwner, status)]};
  padding: 0.5rem 1rem;
  border-radius: 16px;
  color: ${({ theme }) => theme.colors.INK_800};
  max-width: ${({ isOwner }) => (isOwner ? '19.5rem' : '15rem')};
  word-break: break-word;
  box-sizing: border-box;
  line-height: 1.43;

  > a {
    color: ${({ theme }) => theme.colors.PRIMARY_600};
    text-decoration: underline;
  }
`;
const Info = styled.div `
  padding: 0 0.25rem;
  box-sizing: border-box;
  margin-top: auto;
  white-space: nowrap;
`;
const FlexWrapper = styled.div `
  display: flex;
  flex-direction: column;
  > :last-child {
    margin-top: 0.125rem;
  }
`;
const ContainerWithUrl = styled.div `
  display: inline-flex;
  flex-direction: column;
`;
const Content = styled.div `
  display: flex;
  height: fit-content;

  ${({ isOwner }) => isOwner &&
    css `
      margin-left: auto;
      flex-direction: row-reverse;
    `};
`;
const Footer = styled.div `
  display: flex;
`;
const StatusWrapper = styled.div `
  line-height: 0;
  text-align: center;
  > svg {
    vertical-align: middle;
  }
`;
const UrlContainer = styled.a `
  display: inline-flex;
  padding: 0.3rem 0.175rem;

  > span {
    line-height: 1;
    word-break: break-all;
  }

  svg {
    vertical-align: bottom;
  }

  &:hover {
    span {
      color: ${({ theme }) => theme.colors.PRIMARY_600};
    }
    svg > path {
      fill: ${({ theme }) => theme.colors.PRIMARY_600};
    }
  }

  &:active {
    span {
      color: ${({ theme }) => theme.colors.PRIMARY_700};
    }
    svg > path {
      fill: ${({ theme }) => theme.colors.PRIMARY_700};
    }
  }
`;
const UrlText = styled.span `
  text-decoration: underline;
  font-style: italic;
`;
const dateFormatMap = {
    'zh-hant': 'aH:mm',
    'zh-cn': 'aH:mm',
    en: 'HH:mm A',
    vi: 'HH:mm A',
    th: 'HH:mm A',
};
function getRefUrlText(url) {
    const urn = url.replace(/^\w+:\/\//, '');
    const slashIndex = urn.indexOf('/');
    const text = slashIndex < 0 || slashIndex === urn.length - 1
        ? urn // is a root path
        : urn.slice(slashIndex);
    if (text.length > URL_MAX_LENGTH) {
        return (text.slice(0, URL_ELLIPSIS_BEGIN_AT_INDEX) +
            ELLIPSIS_SYMBOL +
            text.slice(-(URL_MAX_LENGTH -
                URL_ELLIPSIS_BEGIN_AT_INDEX -
                ELLIPSIS_SYMBOL.length)));
    }
    return text;
}
const MessageBubble = ({ status, statusText = '', isOwner, text, image, sentAt, refUrl, locale, sendFrom, onImageClick, onImageLoad, }) => {
    const dayJSInstance = dayjs(locale, sentAt);
    let content = null;
    if (image && text) {
        content = (React.createElement(FlexWrapper, null,
            React.createElement(TextWrapper, { isOwner: isOwner, status: status },
                React.createElement(TextLink, { text: text, isPreserveLine: true })),
            React.createElement(ImagePreview.Default, { image: image, onClick: onImageClick, onLoad: onImageLoad })));
    }
    else if (image) {
        content = (React.createElement(ImagePreview.Default, { image: image, onClick: onImageClick, onLoad: onImageLoad }));
    }
    else if (text) {
        content = (React.createElement(TextWrapper, { isOwner: isOwner, status: status },
            React.createElement(TextLink, { text: text, isPreserveLine: true })));
    }
    const statusMap = {
        note: (React.createElement(StatusWrapper, null,
            React.createElement(Text, { lang: locale, fontType: "Micro", color: "INK_400" }, statusText),
            React.createElement(Icons.Outline.Edit, { size: "SMALL", color: "INK_400" }))),
        message: null,
    };
    const info = (React.createElement(Text, { lang: locale, fontType: "Micro", color: "INK_400" }, dayJSInstance.format(dateFormatMap[locale])));
    content = (React.createElement(Content, { isOwner: isOwner },
        content,
        React.createElement(Info, null, sendFrom ? (React.createElement(Tooltip.Primary, { direction: "TOP_CENTER", text: sendFrom, lang: locale },
            statusMap[status],
            info)) : (React.createElement(React.Fragment, null,
            statusMap[status],
            info)))));
    return refUrl && !isOwner ? (React.createElement(ContainerWithUrl, null,
        content,
        React.createElement(Footer, null,
            React.createElement(UrlContainer, { href: refUrl, target: "_blank" },
                React.createElement(Text, { fontType: "Micro", lang: "en", color: "INK_400", weight: "Regular" },
                    React.createElement(Icons.Outline.Link, { size: "XXSMALL", color: "INK_400" }),
                    React.createElement(UrlText, null, getRefUrlText(refUrl))))))) : (content);
};
export default MessageBubble;
//# sourceMappingURL=index.js.map